import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Philosophers are crazy people!",
  "description": "",
  "published": "2010-03-05T00:00:00.000Z",
  "redirect_from": ["/blog/philosophers-are-crazy-people/swizec/1233"],
  "categories": "food for thought, Humor, Paradoxes, Philosophy, Philosophy of Logic, Recreation, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`They seriously are, just look at how well they can take a joke!`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/03/solved.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/03/solved.jpg",
          "alt": null,
          "title": "solved"
        }}></img></a></p>
    <p>{`Dude seriously, the answer to that is "HaHa oh you" not all of `}<em parentName="p">{`that`}</em>{`.`}</p>
    <p>{`Oh well, kudos for proving that caring about paradoxes is just silly because they either don't exist or they do exist and you're a jackass.`}</p>
    <p>{`Also, did you know that if you assume any paradox to be correct you can mathematically prove/derive anything.`}</p>
    <p>{`Point of fact:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2010/03/principle_of_explosion.png",
        "alt": null,
        "title": "XKCD"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/e60ec404-20d8-4ab6-ac8e-4aa72a47f455/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=e60ec404-20d8-4ab6-ac8e-4aa72a47f455",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      